export const formatCurrency = (price: number) => {
  if (!price) return "";
  return price
    .toLocaleString("vi-VN", { style: "currency", currency: "VND" })
    .replace("₫", "đ");
};

export default formatCurrency;
